export default "__VITE_ASSET__QHbeoltK__"